import * as yup from 'yup';

export const validations = yup.object().shape({
  restrictionTypePrice:
    yup
      .string()
      .nullable()
      .test(function(value) {
        if(+this.parent.clientTypeId != 2) {
          return true;
        }

        if(+this.parent.clientTypeId == 2 && !!value) {
          return true;
        }

        return this.createError({
          message: 'Selecione uma tabela para continuar',
          path: 'restrictionTypePrice'
        });
      })
});